<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ companies.id ? "Editar Empresa " : "Cadastrar Empresa" }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group" id="v-step-17">
                          <label for="companyName">
                            <span class="required">*</span> Razão Social:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="companies.company_name"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="companyName">
                            <span class="required">*</span> Nome Fantasia:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="companies.company_name_fantasy"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="cnpj">
                            <span class="required">*</span> CNPJ:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder=""
                            v-model="companies.cnpj"
                            v-mask="'99.999.999/9999-99'"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="email">
                            <span class="required">*</span> E-mail:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            autocomplete="new-password"
                            v-model="companies.email"
                            placeholder=""
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="celphone">
                            <span class="required"></span> Celular:
                          </label>
                          <input
                            autocomplete="new-password"
                            class="form-control"
                            id="celphone"
                            type="text"
                            v-mask="'(99) 99999-9999'"
                            v-model="companies.celphone"
                            placeholder=""
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="telephone">
                            <span class="required"></span> Telefone:
                          </label>
                          <input
                            autocomplete="new-password"
                            type="text"
                            class="form-control"
                            id="telephone"
                            v-model="companies.telephone"
                            v-mask="'(99) 9999-9999'"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="form-group col-md-2">
                        <label for="inputCEP">
                          <span class="required">*</span> CEP
                        </label>
                        <input
                          type="text"
                          v-mask="'99999-999'"
                          class="form-control"
                          v-model="companies.cep"
                          @keyup="buscar()"
                          id="inputCEP"
                        />
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="street">
                            <span class="required">*</span> Logradouro:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="companies.street"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="number">
                            <span class="required">*</span> Nº:
                          </label>
                          <input
                            id="inputNumero"
                            type="number"
                            min="0"
                            oninput="validity.valid||(value='');"
                            class="form-control"
                            placeholder=""
                            v-model="companies.number"
                            autocomplete="new-password"
                            v-mask="'999999'"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="neighborhood">
                            <span class="required">*</span> Bairro:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="companies.neighborhood"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="complement">
                            <span class="required"></span> Complemento:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="companies.complement"
                            placeholder=""
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="city">
                            <span class="required">*</span> Cidade:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="companies.city"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="state">
                            <span class="required">*</span> Estado:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="companies.state"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="status">
                            <span class="required">*</span> Status:
                          </label>
                        </div>
                        <select name="status" id="status" class="form-control" v-model="companies.status">
                          <option value="1">Ativo</option>
                          <option value="0">Inativo</option>
                        </select>
                      </div>
                      <div class="col-md-12">
                        <label>Logo:</label>
                        <br />
                        <input type="file" name="logo" id="logo" />
                      </div>
                      <div class="col-md-2 ml-4 logo-company">
                        <img :src="companies.logo" alt="" />
                      </div>
                    </div>

                    <br />
                    <div class="row" v-if="$store.state.user.access_nivel == 3">
                      <div class="col-md-12">
                        <label for="">
                          <span class="required"></span> Vincular Empresas:
                        </label>
                      </div>
                      <div class="col-md-6">
                        Lista de Empresas:
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Empresa</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody v-if="listCompanies.length > 0">
                            <tr
                              v-for="company in listCompanies"
                              :key="company.id"
                            >
                              <td>{{ company.company_name }}</td>
                              <td>
                                <button
                                  class="btn btn-primary"
                                  @click="vincular(company.id)"
                                >
                                  Vincular
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-6">
                        Empresas Vinculadas:
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Empresa</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody v-if="listLinkedCompanies.length > 0">
                            <tr
                              v-for="company in listLinkedCompanies"
                              :key="company.id"
                            >
                              <td>{{ company.linked_company.company_name }}</td>
                              <td>
                                <button
                                  class="btn btn-primary"
                                  @click="desvincular(company.id)"
                                >
                                  Desvincular
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/companies" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      companies: {
        company_name: "",
        company_name_fantasy: "",
        cnpj: "",
        celphone: "",
        telephone: "",
        email: "",
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
      },
      listCompanies: [],
      listLinkedCompanies: [],
      edereco: [],
      naoLocalizado: false,
    };
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("company_name", self.companies.company_name);
      fd.append("company_name_fantasy", self.companies.company_name_fantasy);
      fd.append("email", self.companies.email);
      fd.append("status", self.companies.status);
      fd.append("cnpj", self.companies.cnpj);
      fd.append("celphone", self.companies.celphone);
      fd.append("telephone", self.companies.telephone);
      fd.append("street", self.companies.street);
      fd.append("number", self.companies.number);
      fd.append("neighborhood", self.companies.neighborhood);
      fd.append("cep", self.companies.cep);
      fd.append("complement", self.companies.complement);
      fd.append("city", self.companies.city);
      fd.append("state", self.companies.state);
      fd.append("_method", "POST");

      let logo = document.getElementById("logo");
      fd.append("logo", logo.files[0] ? logo.files[0] : "");

      if (self.companies.id) {
        fd.append("id", self.companies.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "companies";

      let fd = self.makeFormData();

      if (self.companies.id) {
        api += "/" + self.companies.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/companies");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.companies.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.companies.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputLogradouro").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.companies.street = self.endereco.logradouro;
            self.companies.neighborhood = self.endereco.bairro;
            self.companies.state = self.endereco.uf;
            self.companies.city = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },

    getCompany: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/" + id;
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function () {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.listCompanies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getLinkedCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "linked_companies?id=" + id;
      self.$http
        .get(api)
        .then((response) => {
          self.listLinkedCompanies = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    vincular: function (id) {
      const self = this;
      const api = self.$store.state.api + "linked_companies/";

      var data = {
        company_id: self.companies.id,
        linked_company_id: id,
      };
      self.$http
        .post(api, data)
        .then((response) => {
          self.$message("Sucesso", `Empresa vinculada com sucesso`, "success");
        })
        .then(() => {
          let id = self.$route.params.id;
          if (id) {
            if (self.$store.state.user.access_nivel == 3) {
              self.getCompanies();
              self.getLinkedCompanies(id);
            }
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    desvincular: function (id) {
      const self = this;
      const api = self.$store.state.api + "linked_companies/" + id;

      self.$http
        .delete(api)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Empresa desvinculada com sucesso`,
            "success"
          );
        })
        .then(() => {
          let id = self.$route.params.id;
          if (id) {
            if (self.$store.state.user.access_nivel == 3) {
              self.getCompanies();
              self.getLinkedCompanies(id);
            }
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getCompany(id);
      if (self.$store.state.user.access_nivel == 3) {
        self.getCompanies();
        self.getLinkedCompanies(id);
      }
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style >
.uploading-image {
  display: flex;
  border-radius: 20px;
  width: 250px;
  height: 198px;
}
.logo-company {
  margin-top: 35px;
  background-color: rgb(198, 196, 194);
}
</style>


// WEBPACK FOOTER //
// src/components/Company/Add.vue